﻿(function (win) {
    win.LBSApp = win.LBSApp || {};
    win.LBSApp.Components = win.LBSApp.Components || {};

    win.LBSApp.Components.FAQ = function (
        element, // The element that the component is attached to
    ) {
        const accordionHeaders = element.querySelectorAll('[data-accordion-header]');
        Array.prototype.forEach.call(accordionHeaders, accordionHeader => {
            accordionHeader.addEventListener('click', () => onHeaderClick(accordionHeader));
            const panel = accordionHeader.nextElementSibling;
            updateFocusableState(panel);
        })
    }

    function onHeaderClick(accordionHeader) {
        const isExpanded = accordionHeader.getAttribute('aria-expanded') === 'true' || false;
        const willBeExpanded = !isExpanded;

        const panel = accordionHeader.nextElementSibling;

        accordionHeader.setAttribute('aria-expanded', willBeExpanded);
        panel.setAttribute('aria-hidden', !willBeExpanded);

        if (willBeExpanded) {
            panel.style.maxHeight = panel.scrollHeight + "px";
        } else {
            panel.style.maxHeight = null;
        }
        updateFocusableState(panel)

        const parentPanel = panel.parentElement.closest('[data-accordion-panel]');
        if (!!parentPanel) {
            if (willBeExpanded) {
                parentPanel.style.maxHeight = (parentPanel.scrollHeight + panel.scrollHeight) + "px";
            } else {
                parentPanel.style.maxHeight = (parentPanel.scrollHeight - panel.scrollHeight) + "px";
            }
        }
    }

    // Make every hidden element not focusable.
    // This is for ARIA reasons so that the element is not focusable with for example a keyboard
    function updateFocusableState(rootEl) {
        // loop through all focusable elements
        rootEl.querySelectorAll('button, a').forEach(el => {
            // check if all the panels are exanded or not
            const isParentExpanded = isAllParentPanelsOpen(el);
            const newValue = isParentExpanded ? null : -1;
            el.tabIndex = newValue;
        })
    }

    function isAllParentPanelsOpen(el) {
        var panelEl = el.parentElement.closest('[data-accordion-panel]');
        if (!panelEl) {
            return true;
        }
        const isPanelExpanded = panelEl.getAttribute('aria-hidden') === 'false';
        if (isPanelExpanded == false) {
            return false;
        }
        return isAllParentPanelsOpen(panelEl);
    }

})(window); 